import React, { Component,useState } from 'react';
import api from "../../../services/api";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from '@material-ui/core';
import '../../../pages/Representante_Instituição/Tela_RI_Consultas_Detalhes/styles.css'
import { user_token } from '../../../services/Auth';

var exam_id = localStorage.getItem('exam_id')
var user_id = localStorage.getItem('user_id')
var professional_id = localStorage.getItem('professional_id')
var agent_id = localStorage.getItem('id_agent')

var token = localStorage.getItem(user_token);
export default class DataExam extends Component{
    state = {
        exames: [],
        user: [],
        agent: [],
        professional: [], 
    }

    componentDidMount(){
        this.loadData();
    }
    
    loadData = async () => {
        //Get dos dados da consulta
        const exam_request = await api.get(`/exam/${exam_id}`, { headers: {'x-access-token': token}});
        console.log(exam_request);
        console.log(exam_request.data);
        console.log("Essa é a id do usuário: !!!!" + exam_request);
        this.setState({ exames: exam_request.data });
        
        //Get dos dados do usuário
        const user_request = await api.get(`/user/${user_id}`, { headers: {'x-access-token': token}})
        this.setState({ user: user_request.data});

        //Get dos dados do médico
        const professional_request = await api.get(`/professional/${professional_id}`, { headers: {'x-access-token': token}})
        this.setState({ professional: professional_request.data});

        /* Não está sendo utilizado
        //Get dos dados da instituição
        const agent_request = await api.get(`/agent/${agent_id}`, { headers: {'x-access-token': token}})
        this.setState({ agent: agent_request.data});
        */
    };
    render(){
        return(
            <div id="main-RI-Consultas-Detalhes">
                
                <div id="actions-RI-Consultas-Detalhes">
                    <p id="RI-Consultas-Detalhes">Detalhes do paciente</p>
                    <hr id="divider-RI-Consultas-Detalhes" />
                    { this.state.user.map(patient =>(
                    <div id="collapsed-Consultas-Detalhes-Paciente">
                        <p id="RI-Consultas-Detalhes-Dados">Nome:{patient.name}</p>
                        <p id="RI-Consultas-Detalhes-Dados">CPF: {patient.cpf}</p>
                        <p id="RI-Consultas-Detalhes-Dados">Data de Nascimento: {patient.birth}</p>
                        <p id="RI-Consultas-Detalhes-Dados">Sexo: {patient.gender}</p>
                        <p id="RI-Consultas-Detalhes-Dados">Endereço: {patient.address}</p>
                    </div>
                    ))}
                </div>
                { this.state.exames.map(exams =>(
                <div id="actions-RI-Consultas-Detalhes">
                    <p id="RI-Consultas-Detalhes">Detalhes da consulta</p>
                    <hr id="divider-RI-Consultas-Detalhes" />
                    <div id="collapsed-Consultas-Detalhes-Consulta">
                        <p id="RI-Consultas-Detalhes-Dados">Data da última consulta: {exams.date}}</p>
                        <p id="RI-Consultas-Detalhes-Dados">Notas de observação: {exams.notes}</p>
                        { this.state.professional.map(med =>(
                        <div>
                            <p id="RI-Consultas-Detalhes-Dados">Responsável pela última consulta: {med.name}</p>
                        </div>
                        ))}                        
                    </div>
                </div>
                ))}           
            </div>
        )
    }
}